<template>
  <div>
    <v-container class="pa-3">
      <v-layout row wrap>
        <v-flex
          v-if="$store.state.toaPaintPage.includes(selectedBot.pageid)"
          xs12
          class="text-xs-right"
        >
          <v-btn depressed color="primary" @click="showsearch = true">
            <v-icon>search</v-icon>&nbsp;{{ $t('Advanced Search') }}
          </v-btn>
          <v-btn color="primary" outline depressed :loading="loading" @click="exportXlsx">
            {{ $t('Export') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <div>
        <v-layout row wrap>
          <v-flex xs12>
            <div v-if="loading">
              <scale-loader class="mt-5" :loading="true" :color="'grey'"></scale-loader>
            </div>
            <div v-else>
              <div class="px-2">
                <div style="display: flex">
                  <div style="width: 20%" class="pr-2">
                    <v-card>
                      <div style="background-color: #eee" class="text-xs-center pa-1">Answered</div>
                      <v-divider></v-divider>
                      <div style="font-size: 22px; color: grey" class="pa-2 text-xs-center">
                        {{ databystatus.answered ? databystatus.answered : 0 }}
                      </div>
                    </v-card>
                  </div>
                  <div style="width: 20%" class="pr-2">
                    <v-card>
                      <div style="background-color: #eee" class="text-xs-center pa-1">Pending</div>
                      <v-divider></v-divider>
                      <div style="font-size: 22px; color: grey" class="pa-2 text-xs-center">
                        {{ databystatus.pending ? databystatus.pending : 0 }}
                      </div>
                    </v-card>
                  </div>
                  <div style="width: 20%" class="pr-2">
                    <v-card>
                      <div style="background-color: #eee" class="text-xs-center pa-1">Close</div>
                      <v-divider></v-divider>
                      <div style="font-size: 22px; color: grey" class="pa-2 text-xs-center">
                        {{ databystatus.closed ? databystatus.closed : 0 }}
                      </div>
                    </v-card>
                  </div>
                  <div style="width: 20%" class="pr-2">
                    <v-card>
                      <div style="background-color: #eee" class="text-xs-center pa-1">
                        Cancelled
                      </div>
                      <v-divider></v-divider>
                      <div style="font-size: 22px; color: grey" class="pa-2 text-xs-center">
                        {{ databystatus.cancelled ? databystatus.cancelled : 0 }}
                      </div>
                    </v-card>
                  </div>
                  <div style="width: 20%" class="pr-2">
                    <v-card>
                      <div style="background-color: #eee" class="text-xs-center pa-1">
                        Cold case
                      </div>
                      <v-divider></v-divider>
                      <div style="font-size: 22px; color: grey" class="pa-2 text-xs-center">
                        {{ databystatus.cold_case ? databystatus.cold_case : 0 }}
                      </div>
                    </v-card>
                  </div>
                </div>
              </div>
              <div>
                <v-layout row wrap>
                  <v-flex xs8>
                    <div v-if="databystatus.timestampList" class="mt-2">
                      <OverviewTicketChart
                        :key="apexchartKey"
                        :data="databystatus.timestampList"
                      ></OverviewTicketChart>
                    </div>
                  </v-flex>
                  <v-flex xs4 class="pa-3">
                    <v-layout row wrap>
                      <v-flex xs6 style="border-left: 4px solid rgb(216 216 216)">
                        <div class="pa-2" style="height: 100px">
                          <div class="primary--text" style="font-size: 17px">Received</div>
                          <div style="font-weight: bold">{{ totalticket }}</div>
                        </div>
                      </v-flex>
                      <v-flex xs6 style="border-left: 4px solid rgb(216 216 216)">
                        <div class="pa-2" style="height: 100px">
                          <div class="primary--text" style="font-size: 17px">Resolved</div>
                          <div style="font-weight: bold">
                            {{ databystatus.closed ? databystatus.closed : 0 }}
                          </div>
                        </div>
                      </v-flex>
                      <v-flex class="mt-3" xs6 style="border-left: 4px solid rgb(216 216 216)">
                        <div class="pa-2" style="height: 100px">
                          <div class="primary--text" style="font-size: 17px">
                            Average first response time
                          </div>
                          <div style="font-weight: bold">
                            {{
                              formatAvg(
                                databystatus.first_response_time
                                  ? databystatus.first_response_time
                                  : 0 / databystatus.first_response_time_count
                                  ? databystatus.first_response_time_count
                                  : 0
                              )
                            }}
                          </div>
                        </div>
                      </v-flex>
                      <v-flex class="mt-3" xs6 style="border-left: 4px solid rgb(216 216 216)">
                        <div class="pa-2" style="height: 100px">
                          <div class="primary--text" style="font-size: 17px">
                            Average resolved ticket time
                          </div>

                          <div style="font-weight: bold">
                            {{
                              formatAvg(
                                databystatus.resolved_ticket_time
                                  ? databystatus.resolved_ticket_time
                                  : 0 / databystatus.resolved_ticket_time_count
                                  ? databystatus.resolved_ticket_time_count
                                  : 0
                              )
                            }}
                          </div>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </div>
              <div>
                <v-layout row wrap>
                  <v-flex xs12 class="pl-2">
                    <v-card class="pa-2" color="#eee">
                      <div>
                        <table
                          class="zw-table fullwidth"
                          style="border: none"
                          cellspacing="0"
                          cellpadding="0"
                        >
                          <tr>
                            <td
                              class="text-xs-center primary--text"
                              style="font-weight: bold; text-decoration: underline"
                            >
                              หัวข้อ
                            </td>
                            <td
                              class="text-xs-center primary--text"
                              style="font-weight: bold; text-decoration: underline"
                            >
                              Received
                            </td>
                            <td
                              class="text-xs-center primary--text"
                              style="font-weight: bold; text-decoration: underline"
                            >
                              Resolved
                            </td>
                            <td></td>
                          </tr>
                          <tr v-for="(item, k) in databyclosecasebyadmin" :key="k">
                            <td class="text-xs-center">
                              {{ k }}
                            </td>
                            <td class="text-xs-center">
                              {{ item.recieved }}
                            </td>
                            <td class="text-xs-center">
                              {{ item.resolved }}
                            </td>
                            <td class="text-xs-center">
                              <v-btn
                                icon
                                ripple
                                flat
                                color="primary"
                                @click="onShowDetailsWithSubject(k)"
                              >
                                <v-icon>search</v-icon>
                              </v-btn>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </v-card>
                  </v-flex>
                </v-layout>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </v-container>
    <v-dialog v-model="showsearch" width="700px" persistent>
      <v-card>
        <div class="text-xs-right">
          <v-btn icon @click="showsearch = false"><v-icon>close</v-icon></v-btn>
        </div>
        <div class="pa-2 pt-4 pb-3">
          <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
          <!-- Search info -->
          <div>
            <v-layout class="pa-0 ma-0" wrap>
              <v-flex xs12 sm4 class="form-control pa-1">
                <label>{{ $t('Channel') }}</label>
                <Multiselect
                  v-model="filter.channel"
                  :options="channelOptions"
                  select-label
                  selected-label
                  deselect-label
                ></Multiselect>
              </v-flex>
              <v-flex xs12 sm4 class="form-control pa-1">
                <label>{{ $t('Date From') }}</label>
                <datepicker v-model="filter.dateFrom" color="primary" @input="onSelectedStartDate">
                  <template #default="{ computedDate }">
                    <input
                      type="text"
                      name="date"
                      :value="computedDate"
                      readonly
                      style="color: #000"
                    />
                  </template>
                </datepicker>
              </v-flex>
              <v-flex xs12 sm4 class="form-control pa-1">
                <label>{{ $t('Date To') }}</label>
                <datepicker v-model="filter.dateTo" color="primary" @input="onSelectedEndDate">
                  <template #default="{ computedDate }">
                    <input
                      type="text"
                      name="date"
                      :value="computedDate"
                      readonly
                      style="color: #000"
                    />
                  </template>
                </datepicker>
              </v-flex>
              <v-flex xs12 sm4 class="form-control pa-1">
                <label>{{ $t('Period From') }}</label>
                <Multiselect
                  v-model="filter.periodFrom"
                  :options="periodOption"
                  select-label
                  selected-label
                  deselect-label
                  open-direction="above"
                ></Multiselect>
              </v-flex>
              <v-flex xs12 sm4 class="form-control pa-1">
                <label>{{ $t('Period To') }}</label>
                <Multiselect
                  v-model="filter.periodTo"
                  :options="periodOption"
                  select-label
                  selected-label
                  deselect-label
                  open-direction="above"
                ></Multiselect>
              </v-flex>
            </v-layout>
          </div>
          <div class="text-xs-center mt-3">
            <v-btn outline color="grey" @click="clearsearch">Clear</v-btn>
            <v-btn color="primary" @click="onsearch">Search</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showDetailWithSubjectDialog" width="70%" persistent>
      <v-card class="pa-4">
        <div class="text-xs-right">
          <v-btn icon ripple flat color="primary" @click="closeDetailWithSubjectDialog">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <div class="mt-2">
          <v-pagination
            v-model="pageNumber"
            :total-visible="6"
            :length="pagelength"
            @input="changePage"
          ></v-pagination>
        </div>
        <div>
          <v-data-table
            :loading="loadingDetails"
            :headers="headers"
            :items="databyclosecasebyadminwithsubject"
            class="elevation-1"
            :pagination.sync="pagination"
            hide-actions
          >
            <template #items="props">
              <tr>
                <td>
                  <v-btn
                    icon
                    outline
                    color="primary"
                    @click.stop="goToLivechat(props.item, props.item.channel)"
                  >
                    <em class="fas fa-comments" />
                  </v-btn>
                </td>
                <td>{{ props.item.id }}</td>
                <td>
                  <v-avatar size="30">
                    <img
                      v-if="props.item.profile_pic"
                      :src="props.item.profile_pic"
                      width="30"
                      height="30"
                      :alt="props.item.name"
                      @error="onFailLoad"
                    />
                    <img
                      v-else
                      :src="'/static/img/assets/livechat/profile.png'"
                      width="30"
                      height="30"
                      :alt="props.item.name"
                    />
                  </v-avatar>
                </td>
                <td>{{ props.item.name ? props.item.name : '-' }}</td>
                <td>{{ props.item.subject ? props.item.subject : '-' }}</td>
                <td>{{ props.item.gender ? props.item.gender : '-' }}</td>
                <td>{{ props.item.status ? props.item.status : '-' }}</td>
                <td>
                  <span v-if="props.item.channel == 'facebook'" style="color: #3b5998">
                    <em class="fab fa-facebook-square" />
                  </span>
                  <span v-if="props.item.channel == 'line'" style="color: #00c300">
                    <em class="fab fa-line" />
                  </span>
                </td>
                <td>{{ props.item.starttime | DateFormat('DD/MM/YYYY HH:mm') }}</td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import moment from 'moment'
import OverviewTicketChart from './OverviewTicketChart.vue'
import OverviewAdminChart from './OverviewAdminChart.vue'
import { mapGetters } from 'vuex'
import api from '@/api'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import Multiselect from 'vue-multiselect'
import datepicker from '@/components/elements/DatepickerCustomDialog'
import * as XLSX from 'xlsx'

export default {
  components: {
    DatePickerWithoutButton,
    OverviewTicketChart,
    OverviewAdminChart,
    ScaleLoader,
    Multiselect,
    datepicker
  },
  computed: {
    ...mapGetters(['selectedBot']),
    periodOption() {
      var options = []
      for (var i = 0; i < 24; i++) {
        if (i < 10) {
          options.push(`0${i}:00`)
        } else {
          options.push(`${i}:00`)
        }
      }
      return options
    },
    pagelength() {
      if (this.total) {
        var total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  data() {
    return {
      databystatus: {},
      databyclosecase: {},
      databyclosecasebyadmin: {},
      databyclosecasebyadminwithsubject: [],
      apexchartKey: 0,
      apexchartKeyClosecase: 0,
      filter: {
        pageid: '',
        channel: 'All',
        dateFrom: moment().subtract(3, 'days').format('YYYY-MM-DD'),
        dateTo: moment().format('YYYY-MM-DD'),
        periodFrom: '',
        periodTo: ''
      },
      loading: false,
      totalticket: 0,
      showsearch: false,
      showStartDate: false,
      showEndDate: false,
      channelOptions: ['All', 'Facebook', 'Line'],
      limit: 50,
      offset: 0,
      showDetailWithSubjectDialog: false,
      headers: [
        { text: '', value: '', sortable: false },
        { text: 'Ticket No.', value: 'id', sortable: false },
        { text: '', value: '', sortable: false },
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Subject', value: 'subject', sortable: false },
        { text: 'Gender', value: 'gender', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Channel', value: 'channel', sortable: false },
        { text: 'Period', value: 'period', sortable: false }
      ],
      pagination: { rowsPerPage: -1, sortBy: '' },
      loadingDetails: false,
      pagetmp: 1,
      pageNumber: 1,
      total: 0,
      currentSubject: null
    }
  },
  mounted() {
    this.getAllData()
  },
  methods: {
    formatAvg(secs) {
      const formatted = moment.utc(parseInt(secs) * 1000).format('H[h] m[m] s[s]')
      return formatted
    },
    async getAllData() {
      return new Promise(async (resolve) => {
        var allGet = [
          this.getTicketsByStatus(),
          this.getTicketsCloseCase(),
          this.getTicketsCloseCaseDetailByAdmin()
        ]
        this.loading = true
        await Promise.all(allGet)
        this.loading = false
        resolve()
      })
    },
    onChangeDate() {
      this.getAllData()
    },
    getTicketsCloseCase() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          channel: this.filter.channel.toLowerCase()
        }

        if (this.filter.dateFrom) {
          Object.assign(data, { startDate: this.filter.dateFrom })
        }
        if (this.filter.dateTo) {
          Object.assign(data, { endDate: this.filter.dateTo })
        }
        if (this.filter.periodFrom) {
          Object.assign(data, { startTime: this.filter.periodFrom })
        }
        if (this.filter.periodTo) {
          Object.assign(data, { endTime: this.filter.periodTo })
        }
        api.ticket2CommonGetTicketsCloseCase(data, (err, response) => {
          if (response.data && response.data.length) {
            this.databyclosecase = response.data[0]
          } else this.databyclosecase = {}
          this.apexchartKeyClosecase++
          resolve()
        })
      })
    },
    getTicketsCloseCaseDetailByAdmin() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          channel: this.filter.channel.toLowerCase()
        }

        if (this.filter.dateFrom) {
          Object.assign(data, { startDate: this.filter.dateFrom })
        }
        if (this.filter.dateTo) {
          Object.assign(data, { endDate: this.filter.dateTo })
        }
        if (this.filter.periodFrom) {
          Object.assign(data, { startTime: this.filter.periodFrom })
        }
        if (this.filter.periodTo) {
          Object.assign(data, { endTime: this.filter.periodTo })
        }
        api.ticket2CommonGetTicketsCloseCaseDetailByAdmin(data, (err, response) => {
          if (response.data && response.data.length) {
            this.databyclosecasebyadmin = response.data[0]
          } else this.databyclosecasebyadmin = {}
          resolve()
        })
      })
    },
    getTicketsByStatus() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          channel: this.filter.channel.toLowerCase(),
          limit: this.limit,
          offset: this.offset
        }

        if (this.filter.dateFrom) {
          Object.assign(data, { startDate: this.filter.dateFrom })
        }
        if (this.filter.dateTo) {
          Object.assign(data, { endDate: this.filter.dateTo })
        }
        if (this.filter.periodFrom) {
          Object.assign(data, { startTime: this.filter.periodFrom })
        }
        if (this.filter.periodTo) {
          Object.assign(data, { endTime: this.filter.periodTo })
        }
        api.ticket2CommonGetTicketsByStatus(data, (err, response) => {
          if (response.data && response.data.length) {
            this.databystatus = response.data[0]
            this.totalticket =
              this.databystatus.answered +
              this.databystatus.cancelled +
              this.databystatus.closed +
              this.databystatus.pending
          } else {
            this.databystatus = {}
          }
          this.apexchartKey++
          resolve()
        })
      })
    },
    getTicketsCloseCaseDetailByAdminWithSubject() {
      return new Promise(async (resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          channel: this.filter.channel.toLowerCase(),
          subject: this.currentSubject,
          limit: this.limit,
          offset: this.offset
        }

        if (this.filter.dateFrom) {
          Object.assign(data, { startDate: this.filter.dateFrom })
        }
        if (this.filter.dateTo) {
          Object.assign(data, { endDate: this.filter.dateTo })
        }
        if (this.filter.periodFrom) {
          Object.assign(data, { startTime: this.filter.periodFrom })
        }
        if (this.filter.periodTo) {
          Object.assign(data, { endTime: this.filter.periodTo })
        }
        this.loadingDetails = true
        await api.ticket2CommonGetTicketsCloseCaseDetailByAdminWithSubject(
          data,
          (err, response) => {
            if (err) {
              reject()
              return
            }
            if (response && response.data) {
              this.databyclosecasebyadminwithsubject = response.data
              this.total = response.total
              this.loadingDetails = false
            } else this.databyclosecasebyadminwithsubject = {}
            resolve()
          }
        )
      })
    },
    onShowDetailsWithSubject(subject) {
      this.showDetailWithSubjectDialog = true
      this.currentSubject = subject
      this.getTicketsCloseCaseDetailByAdminWithSubject()
    },
    exportXlsx() {
      let vm = this
      let limit = 500
      let offset = 0

      vm.loadingExport = true
      let data = {
        pageid: this.selectedBot.pageid,
        channel: this.filter.channel.toLowerCase(),
        limit: this.limit,
        offset: this.offset
      }

      if (this.filter.dateFrom) {
        Object.assign(data, { startDate: this.filter.dateFrom })
      }
      if (this.filter.dateTo) {
        Object.assign(data, { endDate: this.filter.dateTo })
      }
      if (this.filter.periodFrom) {
        Object.assign(data, { startTime: this.filter.periodFrom })
      }
      if (this.filter.periodTo) {
        Object.assign(data, { endTime: this.filter.periodTo })
      }

      api.ticket2CommonExportTicketsByStatus(data, (err, response) => {
        if (response && response.data) {
          let dataExport = response.data
          let filename = `Agent-Overview`
          let json = []
          $.each(dataExport, function (index, val) {
            json.push({
              'Ticket No.': val['id'] ? val['id'] : 'NULL',
              Name: val['name'] ? val['name'] : 'NULL',
              Subject: val['subject'] ? val['subject'] : 'NULL',
              Gender: val['gender'] ? val['gender'] : 'NULL',
              Status: val['status'] ? val['status'] : 'NULL',
              Period: val['starttime']
                ? moment(val['starttime']).format('DD/MM/YYYY HH:mm:ss')
                : '-'
            })
          })
          const wb = XLSX.utils.book_new()
          const dataWS = XLSX.utils.json_to_sheet(json)
          XLSX.utils.book_append_sheet(wb, dataWS)
          XLSX.writeFile(wb, `${filename}.xlsx`)
          vm.loadingExport = false
        }
      })
    },
    clearsearch() {
      this.filter = {
        channel: '',
        dateFrom: '',
        dateTo: '',
        periodFrom: '',
        periodTo: ''
      }
      this.onsearch()
    },
    onsearch() {
      this.getAllData()
      this.showsearch = false
    },
    onSelectedStartDate(value, time) {
      if (moment(this.filter.dateTo).isBefore(value)) {
        this.filter.dateTo = value
      }
      if (!time) {
        this.filter.dateFrom = value
      }
      this.showStartDate = false
    },
    onSelectedEndDate(value, time) {
      if (moment(value).isBefore(this.filter.dateFrom)) {
        this.filter.dateFrom = value
      }
      if (!time) {
        this.filter.dateTo = value
      }
      this.showEndDate = false
    },
    closeDetailWithSubjectDialog() {
      this.showDetailWithSubjectDialog = false
      this.currentSubject = null
      this.databyclosecasebyadminwithsubject = []
    },
    onFailLoad: function () {
      this.$set(
        this.databyclosecasebyadminwithsubject,
        'profile_pic',
        '/static/img/assets/livechat/profile.png'
      )
    },
    goToLivechat: function (user, app) {
      let routeData = this.$router.resolve({
        name: 'livechat',
        path: '/' + this.currentLang + '/livechat',
        query: {
          userid: user.userid,
          user: user.context == 'contactadmin' ? 'admin' : 'bot',
          app: app,
          pageid: this.selectedBot.pageid
        }
      })
      window.open(routeData.href, '_blank')
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getTicketsCloseCaseDetailByAdminWithSubject()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toa/agentmanagement/Overview.vue